import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Autocomplete,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDBox from "components/MDBox";
import FormField from "components/FormField";

const CooperatedFormData = ({
  label,
  cooperated,
  gender,
  setGender,
  docType,
  setDocType,
  setInput,
}) => {
  const [step, setStep] = useState(false);

  const [inputValueGender, setInputValueGender] = useState("");

  const optionsGender = ["Masculino", "Feminino"];

  const [inputValueDoc, setInputValueDoc] = useState("");

  const optionsDocument = ["RG", "CNH", "Passaporte", "CTPS", "CDI", "RNE"];

  const genderText = (val) => {
    switch (val) {
      case 1:
        return "Masculino";
      case 2:
        return "Feminino";
      default:
        return val;
    }
  };

  const document = (doc) => {
    switch (doc) {
      case 1:
        return "RG";
      case 2:
        return "CNH";
      case 3:
        return "Passaporte";
      case 4:
        return "CTPS";
      case 5:
        return "CDI";
      case 6:
        return "RNE";
      default:
        return doc;
    }
  };

  return (
    <Accordion
      expanded={step}
      onChange={() => setStep(!step)}
      slotProps={{ transition: { timeout: 400 } }}
      sx={{
        "& .MuiAccordion-region": {
          height: step ? "auto" : 0,
        },
        "& .MuiAccordionDetails-root": {
          display: step ? "block" : "none",
        },
      }}
    >
      <MDBox p={3}>
        <MDBox>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography>{label}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MDBox mt={1.625}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    value={genderText(gender ?? cooperated?.gender)}
                    onChange={(_, newValue) => {
                      setGender(newValue);
                    }}
                    inputValue={inputValueGender}
                    onInputChange={(_, newInputValue) => {
                      setInputValueGender(newInputValue);
                    }}
                    options={optionsGender}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Sexo"
                        required
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    value={document(docType ?? cooperated?.document_type)}
                    onChange={(_, newValue) => {
                      setDocType(newValue);
                    }}
                    inputValue={inputValueDoc}
                    onInputChange={(_, newInputValue) => {
                      setInputValueDoc(newInputValue);
                    }}
                    options={optionsDocument}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Tipo do Documento"
                        required
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Número do Documento"
                    name="document_number"
                    value={cooperated?.document_number}
                    placeholder="Número do Documento"
                    onChange={setInput}
                    required
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Órgão Emissor"
                    name="issuing_body"
                    value={cooperated?.issuing_body}
                    placeholder="Órgão Emissor"
                    onChange={setInput}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="UF"
                    name="document_uf"
                    value={cooperated?.document_uf}
                    placeholder="UF"
                    onChange={setInput}
                    required
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Data de Emissão"
                    name="issue_date"
                    value={cooperated?.issue_date}
                    mask="date"
                    placeholder="Data de Emissão"
                    onChange={setInput}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Nacionalidade"
                    name="nationality"
                    value={cooperated?.nationality}
                    placeholder="Nacionalidade"
                    onChange={setInput}
                    required
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Cidade de Nascimento"
                    name="birth_city"
                    value={cooperated?.birth_city}
                    placeholder="Cidade de Nascimento"
                    onChange={setInput}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="UF de Nascimento"
                    name="birth_uf"
                    value={cooperated?.birth_uf}
                    placeholder="UF de Nascimento"
                    onChange={setInput}
                    required
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Nome da Mãe"
                    name="mothers_name"
                    value={cooperated?.mothers_name}
                    placeholder="Nome da Mãe"
                    onChange={setInput}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Nome do Pai"
                    name="fathers_name"
                    value={cooperated?.fathers_name}
                    placeholder="Nome do Pai"
                    onChange={setInput}
                  />
                </Grid>
              </Grid>
            </MDBox>
          </AccordionDetails>
        </MDBox>
      </MDBox>
    </Accordion>
  );
};

export default CooperatedFormData;
